import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=089205ae&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports